import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { textEllipsis } from 'utils/ellipsis';
import { SecondaryTextSm } from 'atoms';

const template = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: SecondaryTextSm,
      name: 'Property',
      displayValue: ({ order }) => order?.cancelation_reason ? textEllipsis(order.cancelation_reason, 30) : '',
    },
  ],
});
